export default __webpack_public_path__ + "static/media/edit-orange.33dd5e4c.svg";